<template>
  <div class="preview_wrap" v-loading="loading">
    <div class="preview_midle">
      <div class="header">
        <p v-if="stuName">{{stuName}}《{{name}}（{{total}}）》作答详情</p>
        <p v-else>{{name}}（{{total}}）</p>
      </div>
      <div class="tabs">
        <span class="fraction">
          <span style="font-size: 32px;">{{fraction}}</span>
          <img src="../../../../../../static/images/study/icon/underline.png"/>
        </span>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item,index) in questionTabNames"
            :key="index"
            :label="item.sectionAlias || item.sectionName"
            :name="'page'+index"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="section" :style="{height:styleHeight}" @scroll="handleScroll" ref="contents">
        <div class="test">
          <ul>
            <li
              :id="['page'+index]"
              v-for="(item,index) in questionContent"
              :key="index"
              class="test-item"
            >
              <div class="title">
                {{chnNumCharStr(index)}} 、{{item.sectionAlias ||item.sectionName}}
                <span>（{{item.sectionPrompt}}）</span>
              </div>
              <ul>
                <li class="test_small" v-for="(v,i) in item.questions" :key="i">
                  <!--非组合题-->
                  <div v-if="v.internalTypeId !== 6">
                    <div class="text_box">
                      <span class="text_index1" v-if="v.internalTypeId === 9">{{v.questionNum}}.</span>
                      <span class="text_index" v-if="v.internalTypeId !== 9">{{v.questionNum}}.</span>
                      <div class="test_small_title1" v-if="v.internalTypeId === 9">
                        <p class="text" v-html="v.questionContent"></p>
                      </div>
                      <div
                        class="test_small_title"
                        v-html="v.questionContent"
                        v-if="v.internalTypeId !== 9"
                      ></div>
                      <div
                        class="answer_option"
                        v-if="v.internalTypeId === 1 || v.internalTypeId === 2"
                      >
                      </div>


                      <!-- <span>（{{v.answer == 'remark' || ''?'--':v.answer}}）</span> -->
                    </div>
                    <!--单选题-->
                    <ul class="answer" v-if="v.internalTypeId === 1">
                      <div class="answer_radio">
                        <el-radio-group v-model="v.answer">
                          <li v-for="(k,j) in v.items" :key="j">
                            <el-radio
                              :label="k.itemKey"
                              :disabled="v.answer == k.itemKey? false:true"
                            >
                              <span>{{k.itemKey}}：</span>
                              <div class="radio_item" v-html="k.itemValue"></div>
                            </el-radio>
                          </li>
                        </el-radio-group>
                      </div>
                      <img :src="handleJudge(v.isRight)"/>
                    </ul>
                    <!--多选题-->
                    <ul class="answer" v-if="v.internalTypeId === 2">
                      <div class="answer_radio">
                        <el-checkbox-group v-model="v.answer==undefined?'' : v.answer.split(',')">
                          <li v-for="(k,j) in v.items" :key="j">
                            <el-checkbox
                              v-if="v.answer"
                              :disabled="v.answer!='--'?(v.answer.includes(k.itemKey)? false:true):true"
                              :label="k.itemKey"
                            >
                              <span>{{k.itemKey}}：</span>
                              <p v-html="k.itemValue"></p>
                            </el-checkbox>
                            <el-checkbox
                              v-else
                              disabled
                              :label="k.itemKey"
                            >
                              <span>{{k.itemKey}}：</span>
                              <p v-html="k.itemValue"></p>
                            </el-checkbox>
                          </li>
                        </el-checkbox-group>
                      </div>
                      <img :src="handleJudge(v.isRight)"/>
                    </ul>
                    <!--判断题-->
                    <ul class="answer" v-if="v.internalTypeId === 3">
                      <div class="answer_radio">
                        <li>
                          <el-radio
                            v-model="v.answer"
                            label="正确"
                            :disabled="(v.answer=='错误'?true:false)||(v.answer==undefined || '--'?true:false)"
                          >{{ answerExchange(v.englishOption, '正确') }}
                          </el-radio>
                        </li>
                        <li>
                          <el-radio
                            v-model="v.answer"
                            label="错误"
                            :disabled="(v.answer=='正确'?true:false)||(v.answer==undefined || '--'?true:false)"
                          >{{ answerExchange(v.englishOption, '错误') }}
                          </el-radio>
                        </li>
                      </div>
                      <img :src="handleJudge(v.isRight)"/>
                    </ul>
                    <!--实操题-->
                    <!--                    <ul class="answer shicao" v-if="v.internalTypeId === 9">-->
                    <!--                      <img :src="handleJudge(v.isRight)"/>-->
                    <!--                    </ul>-->

                    <div class="answer" v-if="v.internalTypeId === 9">
                      <div class="scoreBoxClass">
                        <span>得分： {{ Number(v.userScore).toFixed(2) }}</span>
                        <span>标准总分： {{ Number(v.score).toFixed(2) }}</span>
                      </div>
                      <span
                        class="answerShow"
                        v-if="v.flag && analysisFlag"
                        @click="checkDetails(v)"
                      >
                        查看评分详情
                      </span>
                    </div>
                    <div class="answerIf">
                      <p
                        v-if="(v.internalTypeId === 1 || v.internalTypeId === 2 || v.internalTypeId === 3)  && analysisFlag"
                      >
                        正确答案：
                        <span>{{ answerExchange(v.englishOption, v.questionAnswer) }}</span>
                      </p>
                      <p
                        v-if="(v.internalTypeId === 1 || v.internalTypeId === 2 || v.internalTypeId === 3) "
                      >
                        我的答案：
                        <span>{{v.answer == 'remark' || v.answer == '' ? '--' : answerExchange(v.englishOption, v.answer) }}</span>
                      </p>
                    </div>
                    <div v-if="v.internalTypeId === 4  && analysisFlag ">
                      正确答案：
                      <p v-html="v.questionAnswer"></p>
                    </div>
                    <div
                      class="analysis"
                      v-if="v.flag && v.internalTypeId !== 9 && analysisFlag  "
                      @click="openAnalysis(v)"
                    >
                      打开解析
                      <img :src="imgSrcDown"/>
                    </div>
                    <div
                      class="analysis"
                      v-if="!v.flag && v.internalTypeId !== 9 && analysisFlag  "
                      @click="openAnalysis(v)"
                    >
                      收起解析
                      <img :src="imgSrcUp"/>
                    </div>
                    <span
                      v-if="!v.flag && v.internalTypeId !== 9 && analysisFlag "
                      class="analysis_cont"
                      v-html="v.questionAnalysis?v.questionAnalysis:'暂无解析'"
                    ></span>


                    <!-- <span
                      class="answerShow"
                      v-if="v.flag && v.internalTypeId === 9 "
                      @click="openAnalysis(v)"
                    >
                      打开答案
                      <img :src="imgSrcDown" />
                    </span>
                    <span
                      class="answerHide"
                      v-if="!v.flag && v.internalTypeId === 9 "
                      @click="openAnalysis(v)"
                    >
                      收起答案
                      <img :src="imgSrcUp" />
                    </span> -->

                    <div class="commentCont" v-if="!v.flag && v.internalTypeId == 9">
                      <div class="comment1"></div>
                      <div class="comment2">
                        <my-component
                          isShow
                          :optObject="optObject"
                          :refresh="refresh"
                          :myId="v.questionId"
                          :type="type"
                          :preview="true"
                          :companyCode="companyCode"
                        ></my-component>
                      </div>
                      <div class="comment3"></div>
                    </div>
                  </div>
                  <!--组合题-->
                  <div class="line" v-if="v.internalTypeId === 6 && item.questions.length > 1"></div>
                  <div class="combination" v-if="v.internalTypeId === 6">
                    <div class="test_small_title1" v-if="v.internalTypeId === 9">
                      <p class="text" v-html="v.questionContent"></p>
                    </div>
                    <p
                      class="question_index"
                      v-if="v.questionNum == v.questionNum + v.childQuestions.length -1"
                    >阅读以下内容，回答第{{v.questionNum}}题</p>
                    <p
                      class="question_index"
                      v-else
                    >阅读以下内容，回答第{{v.questionNum}}-{{v.questionNum + v.childQuestions.length -1}}题</p>
                    <div
                      class="test_small_title"
                      v-html="v.questionContent"
                      v-if="v.internalTypeId !== 9"
                    ></div>
                    <div class="groupQuestion" v-for="(single,m) in v.childQuestions" :key="m">
                      <div class="question_content">
                        <span>{{ single.questionNum }}.</span>
                        <p class="text" v-html="single.questionContent"></p>
                        <div
                          class="answer_option"
                          v-if="single.internalTypeId === 1 || single.internalTypeId === 2"
                        >
                          （
                          <span>{{single.answer == 'remark' || ''?'--':single.answer}}</span>）
                        </div>
                      </div>
                      <!--单选题-->
                      <ul class="answer" v-if="single.internalTypeId === 1">
                        <div class="answer_radio">
                          <el-radio-group v-model="single.answer">
                            <li v-for="(k,j) in single.items" :key="j">
                              <el-radio
                                :label="k.itemKey"
                                :disabled="single.answer == k.itemKey? false:true"
                              >
                                <span>{{k.itemKey}}：</span>
                                <div class="radio_item" v-html="k.itemValue"></div>
                              </el-radio>
                            </li>
                          </el-radio-group>
                        </div>
                        <img :src="handleJudge(single.isRight)"/>
                      </ul>
                      <!--多选题-->
                      <ul class="answer" v-if="single.internalTypeId === 2">
                        <div class="answer_radio">
                          <el-checkbox-group
                            v-model="single.answer==undefined?'' : single.answer.split(',')"
                          >
                            <li v-for="(k,j) in single.items" :key="j">
                              <el-checkbox
                                v-if="single.answer"
                                :disabled="single.answer!='--'?(single.answer.includes(k.itemKey)?false:true):true"
                                :label="k.itemKey"
                              >
                                <span>{{k.itemKey}}：</span>
                                <p v-html="k.itemValue"></p>
                              </el-checkbox>
                              <el-checkbox
                                v-else
                                disabled
                                :label="k.itemKey"
                              >
                                <span>{{k.itemKey}}：</span>
                                <p v-html="k.itemValue"></p>
                              </el-checkbox>
                            </li>
                          </el-checkbox-group>
                        </div>
                        <img :src="handleJudge(single.isRight)"/>
                      </ul>
                      <!--判断题-->
                      <ul class="answer" v-if="single.internalTypeId === 3">
                        <div class="answer_radio">
                          <li>
                            <el-radio
                              v-model="single.answer"
                              label="正确"
                              :disabled="(single.answer=='错误'?true:false)||(single.answer==undefined || '--'?true:false)"
                            >{{ answerExchange(single.englishOption, '正确') }}
                            </el-radio>
                          </li>
                          <li>
                            <el-radio
                              v-model="single.answer"
                              label="错误"
                              :disabled="(single.answer=='正确'?true:false)||(single.answer==undefined || '--'?true:false)"
                            >{{ answerExchange(single.englishOption, '错误') }}
                            </el-radio>
                          </li>
                        </div>
                        <img :src="handleJudge(single.isRight)"/>
                      </ul>
                      <!--实操题-->
                      <!--                      <ul class="answer shicao" v-if="single.internalTypeId === 9">-->
                      <!--                        <img :src="handleJudge(single.isRight)"/>-->
                      <!--                      </ul>-->
                      <div class="answer" v-if="single.internalTypeId === 9">
                        <div class="scoreBoxClass">
                          <span>得分： {{ Number(single.userScore).toFixed(2)  }}</span>
                          <span>标准总分： {{ Number(single.score).toFixed(2)  }}</span>
                        </div>
                        <span
                          class="answerShow"
                          v-if="single.flag && single.internalTypeId === 9  && analysisFlag"
                          @click="checkDetails(single)"
                        >
                          查看评分详情
                        </span>
                      </div>
                      <div class="answerIf">
                        <p
                          v-if="(single.internalTypeId === 1 || single.internalTypeId === 2 || single.internalTypeId === 3) && analysisFlag "
                        >
                          正确答案：
                          <span>{{ answerExchange(single.englishOption, single.questionAnswer) }}</span>
                        </p>
                        <p
                          v-if="(single.internalTypeId === 1 || single.internalTypeId === 2 || single.internalTypeId === 3) "
                        >
                          我的答案：
                          <span>{{v.answer == 'remark' || single.answer == '' ? '--' : answerExchange(single.englishOption, single.answer) }}</span>
                        </p>
                      </div>
                      <div v-if="single.internalTypeId === 4  && analysisFlag">
                        正确答案：
                        <p v-html="single.questionAnswer"></p>
                      </div>
                      <div
                        class="analysis"
                        v-if="single.flag && single.internalTypeId !== 9 && analysisFlag  "
                        @click="openAnalysis(single)"
                      >
                        打开解析
                        <img :src="imgSrcDown"/>
                      </div>
                      <div
                        class="analysis"
                        v-if="!single.flag && single.internalTypeId !== 9 && analysisFlag  "
                        @click="openAnalysis(single)"
                      >
                        收起解析
                        <img :src="imgSrcUp"/>
                      </div>
                      <span
                        v-if="!single.flag && single.internalTypeId !== 9 && analysisFlag "
                        class="analysis_cont"
                        v-html="single.questionAnalysis?single.questionAnalysis:'暂无解析'"
                      ></span>

<!--                      <span-->
<!--                        class="answerShow"-->
<!--                        v-if="single.flag && single.internalTypeId === 9  && analysisFlag"-->
<!--                        @click="checkDetails(single)"-->
<!--                      >-->
<!--                        查看评分详情-->
<!--                      </span>-->

                      <!-- <span
                        class="answerShow"
                        v-if="single.flag && single.internalTypeId === 9 "
                        @click="openAnalysis(single)"
                      >
                        打开答案
                        <img :src="imgSrcDown" />
                      </span>
                      <span
                        class="answerHide"
                        v-if="!single.flag && single.internalTypeId === 9 "
                        @click="openAnalysis(single)"
                      >
                        收起答案
                        <img :src="imgSrcUp" />
                      </span> -->

                      <div class="commentCont" v-if="!single.flag && single.internalTypeId == 9">
                        <div class="comment1"></div>
                        <div class="comment2">
                          <my-component
                            isShow
                            :optObject="optObject"
                            :refresh="refresh"
                            :myId="single.questionId"
                            :type="type"
                            :preview="true"
                            :companyCode="companyCode"
                          ></my-component>
                        </div>
                        <div class="comment3"></div>
                      </div>
                    </div>
                  </div>
                  <div class="line" v-if="v.internalTypeId === 6 && item.questions.length > 1"></div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as api from "../../../../../api/testApi";
  import myComponent from "../../../../myComponent.vue"

  export default {
    data() {
      return {
        name: '',
        styleHeight: window.innerHeight - 110 + "px",
        activeName: 'page0',
        imgSrcDown: '../../../../../../static/images/study/icon/down.png',
        imgSrcUp: '../../../../../../static/images/study/icon/up.png',
        imgFalse: '../../../../../../static/images/study/icon/false.png',
        imgTrue: '../../../../../../static/images/study/icon/true.png',
        imgHalf: '../../../../../../static/images/study/icon/bandui.png',
        imgWufen: '../../../../../../static/images/study/icon/wufen.png',
        fraction: '', //分数
        questionContent: [],
        loading: true,
        questionTabNames: [],
        chnNumChar: ["一", "二", "三", "四", "五", "六", "七", "八", "九"],
        questionJudge: [],
        userType: sessionStorage.getItem('userType'),
        stuName: '',
        total: '',
        optObject: {},
        refresh: true, //刷新数据
        iframeUrl: '',
        type: '',
        productFlag: sessionStorage.getItem('productFlag'),
        companyCode: '',
        analysisFlag: false,  // 能否查看答案 ， 李建龙 2023.5.10
        flag: true,
        template: {},
        subjectId: '',
      }
    },
    components: {
      myComponent,
    },
    created() {
      this.getSubDate();
      this.stuName = this.$route.query.name;
      if (this.productFlag == 3) {
        this.type = 3;
      } else {
        this.type = 2;
      }
    },
    methods: {
      handleClick(tab, event) {
        var PageId = document.querySelector('#' + tab.name);
        this.flag = false;
        let that = this;
        setTimeout(() => {
          that.flag = true
        }, 1000);
        PageId.scrollIntoView();
      },
      // 打开解析
      openAnalysis(param) {
        this.$set(param, 'flag', !param.flag);
        this.optObject = this.$route.query;
        this.getparams(param.questionId);
      },
      // 获取测验预览数据
      getSubDate() {
        let classId = this.$route.query.classId;
        let paperId = this.$route.query.paperId;
        let courseId = this.$route.query.id;
        let userId = this.$route.query.userId;
        let examId = this.$route.query.examId;
        let index = 1;
        api.getStudentPreview(examId, courseId, classId, paperId, userId, this.$route.query.finishFlag).then(res => {
          if (res.code == 0) {
            this.analysisFlag = res.data.isViewAnalysis || this.userType < 2;  // 能否查看答案 ， 李建龙 2023.5.10
            this.fraction = res.data.score;
            this.name = res.data.testPaper.paperName;
            this.total = res.data.testPaper.totalScore + '分';
            this.subjectId = res.data.testPaper.subjectId
            this.questionJudge = res.data.studentPaperRecords;
            this.questionTabNames = res.data.testPaper.testPaperPartsList[0].testPaperSectionsList;
            let testPaperDates = res.data.testPaper.testPaperPartsList[0].testPaperSectionsList;
            testPaperDates.forEach(val => {
              let obj = {};
              obj.sectionName = val.sectionName;
              obj.sectionPrompt = val.sectionPrompt;
              obj.questions = [];
              val.testPaperQuestionsList.forEach((item) => {
                let question = {};
                question.questionId = item.questionId;
                question.score = item.score;
                question.internalTypeId = item.questionDto.internalTypeId;
                question.questionContent = item.questionDto.questionContent;
                question.items = item.questionDto.items;
                question.questionAnswer = item.questionDto.questionAnswer;
                question.englishOption = item.questionDto.englishOption;
                question.questionAnalysis = item.questionDto.questionAnalysis;
                question.questionCode = item.questionDto.questionCode;
                question.questionNum = index++;
                question.flag = true;
                this.questionJudge.forEach((k) => {
                  if (item.questionDto.internalTypeId != 6) {
                    if (k.questionId == item.questionId) {
                      question.answer = k.answer;
                      question.isRight = k.isRight;
                      question.userScore = k.score;
                    }
                  }
                });
                question.childQuestions = [];
                //组合题
                if (item.questionDto.internalTypeId == 6) {
                  index--;
                  item.questionDto.childQuestions.forEach((m) => {
                    let childQuestionsObj = {};
                    childQuestionsObj.internalTypeId = m.internalTypeId;
                    childQuestionsObj.questionContent = m.questionContent;
                    childQuestionsObj.items = m.items;
                    childQuestionsObj.score = m.score;
                    childQuestionsObj.questionAnswer = m.questionAnswer;
                    childQuestionsObj.englishOption = m.englishOption;
                    childQuestionsObj.questionAnalysis = m.questionAnalysis;
                    childQuestionsObj.questionId = m.id;
                    childQuestionsObj.questionCode = m.questionCode;
                    childQuestionsObj.flag = true;
                    childQuestionsObj.questionNum = index++;
                    this.questionJudge.forEach((k) => {
                      if (m.id == k.questionId) {
                        childQuestionsObj.answer = k.answer;
                        childQuestionsObj.isRight = k.isRight;
                        childQuestionsObj.userScore = k.score;
                      }
                    });
                    question.childQuestions.push(childQuestionsObj);
                  });
                }
                obj.questions.push(question);
              });
              this.questionContent.push(obj);
            });
            this.loading = false;
          }
        })
          .catch((error) => {
            console.log(error);
          });
      },
      //阿拉伯数字转中文
      chnNumCharStr(index) {
        return this.chnNumChar[index];
      },
      //每道题的判断处理
      handleJudge(isRight) {
        let imgRoute = "";
        switch (isRight) {
          case 1:
            imgRoute = this.imgTrue;
            break;
          case 0:
            imgRoute = this.imgFalse;
            break;
          case 2:
            imgRoute = this.imgHalf;
            break;
          case 3:
            imgRoute = this.imgWufen;
            break;
          case "":
            imgRoute = this.imgFalse;
            break;
          case undefined:
            imgRoute = this.imgFalse;
            break;
        }
        return imgRoute;
      },
      handleScroll() {
        // return
        if (this.flag == true) {
          let scrollTop = this.$refs.contents.scrollTop;
          let topicLi = document.querySelectorAll(".test-item");
          topicLi.forEach((item, index) => {
            if (scrollTop >= item.offsetTop - 120) {
              this.activeName = "page" + index;
            }
          });
        }
      },
      /**
       *
       *根据资源ID 获取动态参数列表
       */
      getparams(questionId) {
        let list = [];
        return new Promise((resolve) => {
          api
            .getParams(questionId)
            .then((rs) => {
              console.log(rs);
              if (rs.code === "0") {
                if (rs.data.length > 0) {
                  rs.data.map((item) => {
                    if (item.param == "templateCode") {
                      this.companyCode = item.value;
                    }
                    let obj = {
                      key: item.param,
                      value: item.value,
                    };
                    list.push(obj);
                  });
                  resolve(list);
                }
                resolve(list);
              } else {
                this.$messageError(rs.msg);
              }
            })
            .catch(function (error) {
              this.$messageError("后台接口错误！");
            });
        });
      },
      checkDetails(obj) {
        console.log(obj);
        let token = localStorage.getItem('Authorization')
        let classId = this.$route.query.classId;
        let paperId = this.$route.query.paperId;
        let courseId = this.$route.query.id;
        let userId = this.$route.query.userId;
        let examId = this.$route.query.examId;
        // matchPlanId = courseId
        // https://eduresourcetest.cailian.net/#/comparative_score?tabName=jx&id=14376&userId=66963&examType=4&matchPlanId=1883&classId=2606
        // https://eduresourcetest.cailian.net/#/comparative_score?tabName=jx&id=14376&userId=66963&examType=4&examId=1883&classId=2606\
        // console.log(`${process.env.RESOURSE_URL}/#/comparative_score?token=${token}&tabName=jx&id=${obj.questionId}&userId=${userId}&examType=15&examId=${examId}&classId=${classId}&courseId=${courseId}`);
        window.open(`
        ${process.env.RESOURSE_URL}/#/comparative_score?type=comparative_score&token=${token}&paperId=${paperId}&tabName=khcp&id=${obj.questionId}&userId=${userId}&examType=15&examId=${examId}&classId=${classId}&courseId=${courseId}
      `)
      },
      // 判断题 中英文选项
      answerExchange(english, answer) {
        return english
          ? answer == "正确"
            ? "T"
            : answer == "错误"
              ? "F"
              : ""
          : answer;
      },
    },
  };
</script>

<style scoped lang="scss">
  .preview_wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    background: #f4f4f4;

    .preview_midle {
      background: #f4f4f4;
      height: 100%;

      .header {
        padding: 0 183px;

        p {
          height: 56px;
          background: #1d70e2;
          line-height: 56px;
          text-align: center;
          font-size: 18px;
          color: #fff;
          font-family: Source Han Sans CN;
        }
      }

      .tabs {
        padding: 0 183px;
        position: relative;

        .el-tabs {
          background: #fafcfd;
          padding: 0 108px;
          padding-top: 15px;
        }

        /deep/ .el-tabs__item {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: normal;
          color: #999999;
        }

        /deep/ .el-tabs__item.is-active {
          color: #333333;
          font-weight: 600;
        }

        /deep/ .el-tabs__active-bar {
          height: 1px;
          background-color: #333333;
        }

        .fraction {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: absolute;

          color: #f85959;
          top: 5px;
          right: 295px;

          img {
            display: inline-block;
            width: 64px;
            height: 12px;
          }
        }
      }

      .section {
        overflow: auto;
        padding: 0 183px;
        padding-left: 183px;
        padding-right: 177px;

        .test {
          padding: 0 108px;
          background: #fafcfd;
          padding-top: 15px;
          padding-bottom: 20px;
          /*min-height: calc(100% - 40px);*/
          .test-item {
            margin-bottom: 40px;

            .title {
              color: #333333;
              font-size: 16px;
              font-weight: 600;
              margin-bottom: 16px;

              span {
                font-size: 12px;
                font-weight: 400;
              }
            }

            .test_small {
              margin-bottom: 40px;

              .text_index {
                font-size: 14px;
                color: #333333;
                font-weight: 600;
                margin-right: 10px;
              }

              .text_index1 {
                float: left;
                font-size: 14px;
                color: #333333;
                font-weight: 600;
                line-height: 26px;
                margin-right: 10px;
              }

              .answerIf {
                width: 100%;
                overflow: hidden;

                p {
                  float: left;
                  margin-right: 20px;
                }
              }

              .test_small_title {
                font-size: 14px;
                margin-bottom: 16px;
                display: inline-block;

                strong {
                  display: inline-block;
                  white-space: pre-wrap;
                  word-wrap: break-word;
                  box-sizing: border-box;

                  span {
                    line-height: 24px;

                    img {
                      width: 100%;
                    }
                  }
                }

                /deep/ p {
                  display: inline-block;

                  img {
                    width: 100%;
                  }
                }
              }

              .test_small_title1 {
                width: 80%;
                font-size: 14px;
                margin-bottom: 16px;
                float: left;

                p.text {
                  span {
                    line-height: 24px;
                  }

                  /deep/ p {
                    width: 100%;
                    line-height: 26px;

                    img {
                      display: block;
                      max-width: 100%;
                    }
                  }
                }
              }

              .answer_option {
                display: inline-block;

                span {
                  display: inline-block;
                  padding: 0 30px;
                  color: #5397f7;
                  font-size: 14px;
                }
              }

              .panduan {
                line-height: 24px;
              }

              .answer {
                margin-left: 34px;
                margin-top: 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                clear: both;

                li {
                  margin-bottom: 16px;

                  /deep/ .el-radio__input.is-disabled {
                    .el-radio__inner {
                      cursor: pointer;
                    }
                  }

                  /deep/ .el-radio__input.is-disabled + span.el-radio__label {
                    cursor: pointer;
                    color: #606266;
                  }

                  /deep/ .el-radio__label {
                    .radio_item {
                      display: inline-flex;
                      width: 96%;
                      white-space: pre-wrap;
                      word-wrap: break-word;
                    }

                    p {
                      display: inline-block;
                      white-space: pre-wrap;
                      word-wrap: break-word;
                      box-sizing: border-box;
                      width: 90%;

                      img {
                        width: 100%;
                      }
                    }
                  }

                  /deep/ .el-checkbox__label {
                    p {
                      display: inline-flex;
                      white-space: pre-wrap;
                      word-wrap: break-word;
                      box-sizing: border-box;
                      width: 96%;
                    }
                  }

                  /deep/ .el-radio__input.is-disabled {
                    .el-radio__inner {
                      background-color: #fff;
                    }
                  }

                  /deep/ .el-checkbox__input.is-disabled {
                    .el-checkbox__inner {
                      background-color: #fff;
                    }
                  }

                  /deep/
                  .el-checkbox__input.is-disabled
                  + span.el-checkbox__label {
                    cursor: pointer;
                    color: #606266;
                  }
                }

                img {
                  width: 164px;
                  height: 100px;
                  right: 0;
                }
              }

              /*.shicao {*/
              /*  text-align: right;*/
              /*  display: inherit;*/
              /*}*/

              p {
                font-size: 14px;
                margin-bottom: 12px;

                span {
                  color: #5397f7;
                }
              }

              .analysis {
                color: #5397f7;
                font-size: 14px;
                cursor: pointer;
                float: left;

                img {
                  display: inline-block;
                  width: 10px;
                  height: 10px;
                  margin-left: 4px;
                }
              }

              .analysis_cont {
                float: left;
                width: calc(100% - 105px);
                color: #333333;
                font-size: 14px;
                line-height: 24px;
                margin-bottom: 32px;
                margin-left: 24px;
                margin-top: -4px;
              }

              .scoreBoxClass {
                font-size: 13px;
                font-weight: 600;
                display: flex;
                flex-direction: row;
                gap: 40px;
                color: #0d0d0d;
              }

              .answerShow,
              .intoSystem,
              .answerHide {
                color: #5397f7;
                font-size: 14px;
                cursor: pointer;

                img {
                  display: inline-block;
                  width: 10px;
                  height: 10px;
                  margin-left: 4px;
                }
              }

              .intoSystem {
                margin-left: 40px;
              }

              .commentCont {
                position: relative;

                .comment1 {
                  width: 0px;
                  height: 0px;
                  border: 8px transparent solid;
                  border-bottom-color: #f4f4f4;
                  position: absolute;
                  top: -15px;
                  left: 41px;
                }

                .comment2 {
                  background: #f4f4f4;
                  /*min-height: 105px;*/
                  /*max-height: 396px;*/
                  height: 396px;
                  border-radius: 4px;
                  margin-top: 10px;
                  padding: 16px;
                  overflow: auto;
                }

                .comment3 {
                  width: 0px;
                  height: 0px;
                  border: 9px transparent solid;
                  border-bottom-color: rgba(244, 244, 244, 1);
                  position: absolute;
                  top: -15px;
                  left: 40px;
                }
              }

              .combination {
                padding-top: 15px;
                padding-bottom: 25px;

                .groupQuestion {
                  /*clear: both;*/
                  margin-bottom: 10px;
                }

                .analysis {
                  margin-bottom: 15px;
                }

                .test_small_title {
                  /deep/ p {
                    line-height: 26px;
                  }
                }

                .question_index {
                  display: block;
                  font-weight: 600;
                  font-size: 14px;
                }

                .question_content {
                  width: 80%;
                  overflow: hidden;
                  /*float: left;*/
                  display: flex;
                  flex-direction: row;

                  span {
                    margin-right: 10px;
                    line-height: 21px;
                    font-weight: 600;
                  }

                  p.text {
                    display: inline-block;
                    max-width: 74%;

                    /deep/ p {
                      display: inline-block;
                      line-height: 24px;

                      img {
                        display: block;
                        max-width: 100%;
                      }
                    }
                  }
                }
              }

              .line {
                height: 0px;
                border: 1px solid rgba(83, 151, 247, 1);
              }
            }
          }
        }
      }
    }
  }

  .text_box {
    width: 100%;
    display: flex;
    justify-content: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testing/stuPreview.vue